import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { TestFreeTest } from "./TestFreeTest";
import { Button } from "primereact/button";
import { translate } from "../localization/translateService";
import preTestCloseConfirmImage from "../stories/assets/pre-test-close-image.svg";

export default function PreTestModal({ isPreTestModalOpen, closePreTestModal }) {
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isNeedConfirmModal, setIsNeedConfirmModal] = useState(true);

  const [preTestTranslations, setPreTestTranslations] = useState({
    yesButtonLabel: "",
    noButtonLabel: "",
    preTestTitle: "",
    confirmHeaderTitle: "",
    confirmBodyTitle: "",
    congratsTitle: "",
  });

  const [preTestModalHeaderTitle, setPreTestModalHeaderTitle] = useState("");

  const handleOnCloseModal = () => {
    if (!isPreTestModalOpen) return;
    if (isNeedConfirmModal) {
      setConfirmModalOpen(true);
    } else {
      closePreTestModal();
    }
  };

  const handleForceCloseModal = () => {
    if (!isPreTestModalOpen) return;
    closePreTestModal();
  };

  const handleOnCloseConfirmModal = () => {
    if (!confirmModalOpen) return;
    setConfirmModalOpen(false);
  };

  const handleConfirmAcceptButton = () => {
    setConfirmModalOpen(false);
    closePreTestModal();
  };

  const handleSetIsNeedConfirmModal = (value) => {
    setIsNeedConfirmModal(value);
    if (!value) {
      setPreTestModalHeaderTitle(preTestTranslations.congratsTitle);
    }
  };

  useEffect(() => {
    const loadTranslations = async () => {
      const preTestTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.PRE_TEST");
      const confirmHeaderTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.CONFIRM_HEADER_TITLE");
      const yesButtonLabel = await translate("UMBRACO_LANDING.FREE_TEST.BUTTON.YES");
      const noButtonLabel = await translate("UMBRACO_LANDING.FREE_TEST.BUTTON.NO");
      const confirmBodyTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.CONFIRM_BODY");
      const congratsTitle = await translate("UMBRACO_LANDING.FREE_TEST.TITLE.CONGRATS");

      setPreTestTranslations({
        yesButtonLabel,
        noButtonLabel,
        preTestTitle,
        confirmHeaderTitle,
        confirmBodyTitle,
        congratsTitle,
      });

      setPreTestModalHeaderTitle(preTestTitle);
    };

    loadTranslations();
  }, []);

  return (
    <div className="pre-test-wrapper">
      <Dialog
        draggable={false}
        visible={isPreTestModalOpen}
        className="kedual-dialog-free-test keduall-dialog pre-test-modal"
        onHide={handleOnCloseModal}
        header={preTestModalHeaderTitle}
        autoFocus={false}
        blockScroll={true}
        contentClassName="keduall-scrollbar"
        baseZIndex="10001"
      >
        <div>
          <TestFreeTest handleForceCloseModal={handleForceCloseModal} handleCloseModal={handleOnCloseModal} setIsNeedConfirmModal={handleSetIsNeedConfirmModal} />
        </div>
      </Dialog>
      <Dialog
        draggable={false}
        visible={confirmModalOpen}
        className=" kedual-dialog-free-test keduall-dialog pre-test-modal pre-test-modal-confirm"
        onHide={handleOnCloseConfirmModal}
        header={preTestTranslations?.confirmHeaderTitle}
      >
        <div className="flex flex-column gap-40 justify-content-between align-items-center">
          <img src={preTestCloseConfirmImage} alt="keduall-logo" />
          <h3 className="keduall-typography heading-h4-normal-400 text-third-txt-color max-width-512 text-center">{preTestTranslations?.confirmBodyTitle}</h3>
          <div className="flex flex-wrap justify-content-center">
            <Button className="keduall-buttons button-text-large-secondary" onClick={handleConfirmAcceptButton}>
              <h6 className="keduall-typography heading-h6-semibold-600">{preTestTranslations?.yesButtonLabel}</h6>
            </Button>
            <Button className="keduall-buttons button-filled-default-large-primary" onClick={() => setConfirmModalOpen(false)}>
              <h6 className="keduall-typography heading-h6-semibold-600">{preTestTranslations?.noButtonLabel}</h6>
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
